import { render, staticRenderFns } from "./GerkStatusCell.vue?vue&type=template&id=174d7374&"
import script from "./GerkStatusCell.vue?vue&type=script&lang=js&"
export * from "./GerkStatusCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports